import type {
  SortDirection,
  SuggestedPoSortField,
} from "./shippingPoGeneration.ts";

export type ShippingPoLayout = "grid" | "rail";
export const SHIPPING_PO_LAYOUT_STORAGE_KEY = "redisku.shipping-pos.layout.v1";

/** Workspace-owned presentation state consumed by the section header. */
export interface ShippingPoWorkspaceControls {
  generate: () => void;
  readonly hasResult: boolean;
  readonly loading: boolean;
  readonly layout: ShippingPoLayout;
  readonly sortField: SuggestedPoSortField;
  readonly sortDirection: SortDirection;
  selectLayout: (value: ShippingPoLayout) => void;
  selectSortField: (value: SuggestedPoSortField) => void;
}
